import { unsafeCSS } from 'lit-element';

/*
 * Conveniently retrieve theme data values
 *
 * This retrieves values from the js var `themeData`. Use a dot seperated path
 * to the keys in the object you want to get the value from. For example:
 *
 *   themeData('buttons.size.normal.font_size')
 *
 * Will work like:
 *
 *   jsVar('themeData').buttons.size.normal.font_size
 *
 * Unless any of the keys don't exist. Then it returns the `defaultValue`,
 * which is `null` by default.
 */
export function themeData(path, defaultValue=null) {

  let data = jsVar('themeData');
  const keys = path.split('.');

  for (const key of keys) {
    if (typeof data === 'object' && key in data) {
      data = data[key];
    } else {
      return defaultValue;
    }
  }

  return data;

}


function isObject(varVar) {
  if (
    typeof varVar === 'object' &&
    !Array.isArray(varVar) &&
    varVar !== null
  ) {
    return true;
  }
}


/*
 * Version of `themeData()` which returns the result wrapped in Lit's `unsafeCSS()`
 *
 * This makes the variables usable in CSS templates.
 */
export function cssThemeData(path, defaultValue=null) {

  let data = themeData(path, defaultValue);

  if (
    isObject(data)
    && !data.hasOwnProperty('cssText')
    && data.hasOwnProperty('base')
  ) {
    data = data.base;
  }

  return unsafeCSS(data);

}
